module.exports = __webpack_public_path__ + "8b1c897a355c11925d38e643ef80e537.svg";